import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useContext } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import { serverInfo } from "../../../App";
import useFileHandleS3 from "../../../CustomHooks/useFileHandleS3";
import MediaUploadProgressBar from "../../MediaUploadProgressBar";

export default function LiveChatEdit(props) {
  const history = useHistory();
  const { imageCdnUrl } = useContext(serverInfo);
  const [convertedContent, setConvertedContent] = useState("");
  const [instruction, setInstruction] = useState("");
  const [loading, setLoading] = useState(false);

  // File Handle
  const fileInputRef = useRef(null);
  const [filePath, setFilePath] = useState("");
  const [file, setFile] = useState("");
  const [delKey, setDelKey] = useState(null);
  const [fileUrl,fileKey,progress] = useFileHandleS3(file,'livechat/images',delKey);

  const [registerInput, setRegister] = useState({
    id: "",
    slug: "",
    title: "",
    description: "",
    event_date: "",
    start_time: "",
    end_time: "",
    registration_start_date: "",
    registration_end_date: "",
    max_time: "",
    min_time: "",
    total_seat: "",
    interval: "",
    fee: "",
    error_list: [],
  });

  const handleInput = (e) => {
    const { name, value } = e.target;
    setRegister((prev) => {
      return { ...prev, [name]: value };
    });
  };
  const deleteFile = ()=>
  {
    setFile(null);
    setDelKey(fileKey);
    fileInputRef.current.value = '';

  }

  const handleChange = (file) => {
    setDelKey(fileKey);
    setFile(file[0]);
  };

  const registerSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const fData = new FormData();

    fData.append("id", registerInput.id);
    fData.append("image", fileKey?fileKey:filePath);
    fData.append("title", registerInput.title);
    fData.append("star_id", registerInput.star_id);
    fData.append("instruction", instruction);
    fData.append("description", convertedContent);
    fData.append("date", registerInput.event_date);
    fData.append("start_time", registerInput.start_time);
    fData.append("end_time", registerInput.end_time);
    fData.append(
      "registration_start_date",
      registerInput.registration_start_date
    );
    fData.append("registration_end_date", registerInput.registration_end_date);
    fData.append("fee", registerInput.fee);
    fData.append("max_time", registerInput.max_time);
    fData.append("min_time", registerInput.min_time);
    fData.append("interval", registerInput.interval);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.post(`/api/star/update_live_session`, fData).then((res) => {
        setLoading(false);
        if (res.data.status === 200) {
          if(file){
            setFile('');
            setDelKey(filePath.split("com/").pop())
          }

          swal("Success", res.data.message, "success");
          history.push(`/superstar/live-chat/details/${res.data.event?.id}`);
        } else {
          setRegister({
            ...registerInput,
            error_list: res.data.validation_errors,
          });
        }
      });
    });
  };

  useEffect(() => {
    const event_id = props.match.params.id;

    axios.get(`/api/star/live-chat/details/${event_id}`).then((res) => {
      if (res.data.status === 200) {
        setRegister(res.data.event);
        setConvertedContent(res.data.event?.description);
        setInstruction(res.data.event?.instruction);
        setFilePath(res.data.event?.banner);
      }
    });
  }, [props.match.params.slug, history]);

  return (
    <>
      <div className="card card-bg head-line mb-2">
        <div className="text-light d-flex justify-content-center p-2">
          <div className="faTrophy">
            <i className="fa-solid fa-calendar-plus"></i>
          </div>
          <h4 className="mx-3 text-warning p-2">Edit Live Session Event</h4>
        </div>
      </div>
      <div
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <div className="card card-bg mb-2 p-2 ">
          <div className="card card-bg m-2">
            <div className="container-lg">
              <div className="row">
                <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                  <form
                    className="p-3"
                    onSubmit={registerSubmit}
                    id="input_form"
                    encType="multipart/form-data"
                  >
                    <div className="form-group row my-4">
                      <label className="col-sm-3 label-text ">
                        Purpose of live
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control reply-control"
                          placeholder="write here.."
                          onChange={handleInput}
                          name="title"
                          value={registerInput.title}
                        />
                        <small className="text-danger">
                          {registerInput.error_list?.title}
                        </small>
                      </div>
                    </div>

                    <div className="form-group row my-4">
                      <label className="col-sm-3 label-text ">
                        Description
                      </label>
                      <div className="col-sm-9">
                        <CKEditor
                          editor={ClassicEditor}
                          data={convertedContent}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            setConvertedContent(data);
                          }}
                        />
                        <small className="text-danger">
                          {registerInput.error_list?.description}
                        </small>
                      </div>
                    </div>

                    <div className="form-group row my-4">
                      <label className="col-sm-3 label-text ">
                        Instruction
                      </label>
                      <div className="col-sm-9">
                        <CKEditor
                          editor={ClassicEditor}
                          data={instruction}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            setInstruction(data);
                          }}
                        />
                        <small className="text-danger">
                          {registerInput.error_list?.instruction}
                        </small>
                      </div>
                    </div>

                    <div className="form-group row my-3">
                      <label className="col-sm-3 label-text ">Banner</label>

                      <div className="col-sm-5 file-x-i">
                      {fileUrl && file ? (
                           <div className="position-relative">
                    
                           <img
                           src={fileUrl}
                           className="img-fluid avatar-img-src"
                           alt=""
                           style={{ maxHeight: "300px" }}
                         />  
                        <span className="text-warning right-cross-button" onClick={deleteFile}>X</span>
                         </div>
                      ) : (
                        <img
                          src={imageCdnUrl + filePath}
                          className="img-fluid avatar-img-src"
                          alt=""
                          style={{ maxHeight: "300px" }}
                        />
                      )}
                        <input
                          type="file"
                          accept="image/*"
                          className="form-control reply-control"
                          onChange={(e) => handleChange(e.target.files)}
                          id="image"
                          name="image"
                          ref={fileInputRef}
                        />
                       {file && !fileUrl && <MediaUploadProgressBar progress={progress} />}
                        <small className="text-danger">
                          {registerInput.error_list?.image}
                        </small>
                      </div>
                    </div>

                    <div className="form-group row my-4">
                      <label className="col-sm-3 label-text ">Event Date</label>
                      <div className="col-sm-4">
                        <input
                          type="date"
                          className="form-control reply-control"
                          onChange={handleInput}
                          name="event_date"
                          value={registerInput.event_date}
                        />
                        <span className="text-danger">
                          {registerInput.error_list?.event_date}
                        </span>
                      </div>
                    </div>

                    <div className="form-group row my-3 text-warning">
                      <label className="col-sm-3 label-text ">Event Time</label>
                      <div className="col-sm-4">
                        <input
                          type="time"
                          className="form-control reply-control"
                          onChange={handleInput}
                          name="start_time"
                          value={registerInput.start_time}
                        />
                        <span className="text-danger">
                          {registerInput.error_list?.start_time}
                        </span>
                      </div>{" "}
                      To
                      <div className="col-sm-4">
                        <input
                          type="time"
                          className="form-control reply-control"
                          onChange={handleInput}
                          name="end_time"
                          value={registerInput.end_time}
                        />
                        <span className="text-danger">
                          {registerInput.error_list?.end_time}
                        </span>
                      </div>
                    </div>

                    <div className="form-group row my-3 text-warning">
                      <label className="col-sm-3 label-text ">
                        Registration Start
                      </label>
                      <div className="col-sm-4">
                        <input
                          type="date"
                          className="form-control reply-control"
                          onChange={handleInput}
                          name="registration_start_date"
                          value={registerInput.registration_start_date}
                        />
                        <span className="text-danger">
                          {registerInput.error_list?.registration_start_date}
                        </span>
                      </div>{" "}
                      To
                      <div className="col-sm-4">
                        <input
                          type="date"
                          className="form-control reply-control"
                          onChange={handleInput}
                          name="registration_end_date"
                          value={registerInput.registration_end_date}
                        />
                        <span className="text-danger">
                          {registerInput.error_list?.registration_end_date}
                        </span>
                      </div>
                    </div>

                    <div className="form-group row my-3">
                      <label className="col-sm-3 label-text ">
                        Minimum Chatting Time
                      </label>
                      <div className="col-sm-5">
                        <input
                          type="number"
                          min={0}
                          className="form-control reply-control"
                          placeholder="00"
                          onChange={handleInput}
                          name="min_time"
                          value={registerInput.min_time}
                        />
                        <span className="text-danger">
                          {registerInput.error_list?.min_time}
                        </span>
                      </div>
                    </div>

                    <div className="form-group row my-3">
                      <label className="col-sm-3 label-text ">
                        Maximum Chatting Time
                      </label>
                      <div className="col-sm-5">
                        <input
                          type="number"
                          min={0}
                          className="form-control reply-control"
                          placeholder="00"
                          onChange={handleInput}
                          name="max_time"
                          value={registerInput.max_time}
                        />
                        <span className="text-danger">
                          {registerInput.error_list?.max_time}
                        </span>
                      </div>
                    </div>

                    <div className="form-group row my-3">
                      <label className="col-sm-3 label-text ">
                        Time Interval
                      </label>
                      <div className="col-sm-5">
                        <input
                          type="number"
                          min={0}
                          className="form-control reply-control"
                          placeholder="00"
                          onChange={handleInput}
                          name="interval"
                          value={registerInput.interval}
                        />
                        <span className="text-danger">
                          {registerInput.error_list?.interval}
                        </span>
                      </div>
                    </div>

                    <div className="form-group row my-3">
                      <label className="col-sm-3 label-text ">
                        Fee Per Minute
                      </label>
                      <div className="col-sm-5">
                        <input
                          type="number"
                          min={0}
                          className="form-control reply-control"
                          placeholder="00"
                          onChange={handleInput}
                          name="fee"
                          value={registerInput.fee}
                          step="0.01"
                        />
                        <span className="text-danger">
                          {registerInput.error_list?.fee}
                        </span>
                      </div>
                    </div>

                    {/* Update */}
                    <div className="d-flex justify-content-center aligns-items-center my-4 mt-5">
                      <div className="col-sm-12 col-md-3 col-lg-2">
                        {loading ? (
                          <>
                            <button className="btn btnUpdate">
                              <i className="fas fa-spinner fa-pulse"></i>{" "}
                            </button>
                          </>
                        ) : (
                          <button
                            className="btn btnUpdate fw-bold"
                            type="submit"
                          >
                            Update
                          </button>
                        )}
                      </div>
                    </div>
                    {/* Update End */}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
